import { ElementRef, Inject, Injectable } from '@angular/core';
import { geojson } from '@lib/geojson';
import Map from 'ol/Map';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { MapCustomButtons } from '@app/utilities/map/interactions/buttons';
import { Subject } from 'rxjs';
import { Marker } from '@app/utilities/map/features/marker';
import { TooltipManager } from '@app/utilities/map/features/tooltip';
import { PolygonManager } from '@app/utilities/map/features/polygon';
import { DialogService } from '@app/old-ui/dialog/dialog.service';
import { WebClient } from '@injectables';
import { Feature, View } from 'ol';
import { Point } from 'ol/geom';
import { PolylineManager } from '@app/utilities/map/features/polyline';
import { createMapSatelliteLayer } from '@app/utilities/map/ol/satellite-layer';

@Injectable({
    providedIn: 'root',
})
export class TaggedMuckpileMapService {
    public map: Map | null = null;
    public mapButtons: MapCustomButtons | null = null;
    public markerManager: Marker | null = null;
    public tooltipManager: TooltipManager | null = null;
    public polygonManager: PolygonManager | null = null;
    public polylineManager: PolylineManager | null = null;
    public drawerToggle$ = new Subject<void>();
    public readonly deviceClient = this.webClient.model.device;
    private markersMap: { [key: string]: Feature<Point> } = {};
    private mapElementRef: HTMLElement | null = null;
    private mapCenter: geojson.Coord = [0, 0];
    private mapZoom: number = 17;

    constructor(
        private fragQuery: FragQueryService,
        @Inject(DialogService) private readonly dialog: DialogService,
        private readonly webClient: WebClient,
    ) {}

    public initializeMap(center: geojson.Coord, mapElement: ElementRef) {
        this.mapCenter = center; // Store initial center
        this.mapZoom = 17; // Store initial zoom
        this.mapElementRef = mapElement.nativeElement; // Store element
        this.initializeBaseSatelliteLayer(mapElement.nativeElement, center, 17);
        this.mapButtons = new MapCustomButtons(mapElement.nativeElement);
        this.tooltipManager = new TooltipManager(this.map);
        this.polygonManager = new PolygonManager(this.map, this.tooltipManager);

        // this.fragQuery.muckpile$.subscribe(muckpile => {
        //     const geometry = muckpile.geometry;
        //     this.mapCenter = geometry.coordinates[0][0]; // Store center
        //     this.reCenterMap(geometry.coordinates[0][0], 17);
        //     this.polygonManager?.add({
        //         coordinates: geometry.coordinates,
        //         content: muckpile.name,
        //         color: '#5d7af6'
        //     })
        // })
    }

    public initializeBaseSatelliteLayer(
        mapElement: HTMLElement,
        center: geojson.Coord,
        zoom: number
    ) {
        // Initialize the OpenLayers map with Google Maps as the base layer
        this.map = new Map({
            target: mapElement,
            layers: [createMapSatelliteLayer()],
            view: new View({
                center: center,
                zoom: zoom
            }),
            controls: []
        });
        return this.map;
    }

    public reCenterMap(center: geojson.Coord, zoom?: number) {
        if (this.map) {
            const view = this.map.getView();
            view.setCenter(center);
            if (zoom !== undefined) {
                view.setZoom(zoom);
            }
        }
    }

    public cleanup() {
        if (this.map) {
            this.map.dispose();
            this.map = null;
        }
        this.mapButtons = null;
        this.markerManager = null;
        this.tooltipManager = null;
        this.polygonManager = null;
        this.polylineManager = null;
        this.mapElementRef = null;
    }

    public addPolygon(props: {
        coordinates: geojson.Coord[][],
        title: string;
        color: string,
    }) {
        const content = `<div class="map-marker" style="padding: 5px; border-radius: 5px;">
                            ${props.title}
                        </div>`;

        this.polygonManager.add({
            coordinates: props.coordinates,
            content,
            color: props.color
        })
    };
}
